import { Booking } from "@ciptex/notified";
import { Box } from "@twilio-paste/core/box";
import { FC } from "react";
import { PopOverMaker } from "./PopOverMaker";

interface EventType {
    booking: Booking | undefined;
  }

export const EventInfo: FC<EventType> = ({ booking  }) => {
	return (<Box display="flex" flexDirection="row" flexWrap="wrap" flex="9" columnGap="space30" rowGap="space30">
		{booking?.event.usage && <PopOverMaker title={booking?.event.usage} description="Usage of the event" />}
		{booking?.event?.serviceLevel && <PopOverMaker title={booking?.event.serviceLevel} description="Service Level of the event" />}
		{booking?.event?.id && <PopOverMaker title={booking?.event.id} description="ID of the event" />}
	</Box>);
}
